import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonTextarea from '../../../../../../components/common-textarea/CommonTextarea';
import CommonButton from '../../../../../../components/common-button/CommonButton';

import scss from './EditSection.module.scss';

function EditSection({ preview, onChange, onDiscard, onSave }) {
  const { t } = useTranslation('activ8');

  return (
    <div className={scss.editSection}>
      <CommonTextarea value={preview} onChange={onChange} rows='5' />

      <div className={scss.editSectionActions}>
        <CommonButton styleColor='secondary' maxWidth={120} onClick={onDiscard}>
          {t('discard')}
        </CommonButton>

        <CommonButton styleColor='primary' maxWidth={120} onClick={onSave}>
          {t('saveChanges')}
        </CommonButton>
      </div>
    </div>
  );
}

export default EditSection;
